<template>
  <Layout :tituloPagina="'Network | Routers'">
    <div class="row mb-3">
      <div class="col-md-2 col-2">
        <div class="d-flex flex-wrap gap-2">
          <router-link class="btn btn-success" :to="{ name: 'estadoRed' }">
            <span class="d-none d-sm-block">
              <i class="mdi mdi-server-network"></i>
              Estado de red
            </span>
            <span class="d-block d-sm-none">
              <i class="mdi mdi-server-network"></i>
            </span>
          </router-link>
          <button
            class="btn btn-white btn-sm"
            @click="mostrarMdlFiltros()"
            title="Columnas"
          >
            <span class="d-none d-sm-block">
              <i class="mdi mdi-format-list-bulleted"></i>
              Filtros
            </span>
            <span class="d-block d-sm-none">
              <i class="mdi mdi-format-list-bulleted"></i>
            </span>
          </button>
        </div>
      </div>
      <div class="col-md-8 col-8 mb-3">
        <filtrador
          v-on:dato-actualizado="
            dato = $event,
            refrescarRouters()
          "
          :datoini="dato"
          placeholder="Dato del router"
        ></filtrador>
      </div>
      <div class="col-md-2 col-2 text-right">
        <router-link class="btn btn-success" :to="{ name: 'nuevoRouter' }">
          <span class="d-none d-sm-block">
            <i class="mdi mdi-plus-thick"></i>
            Nuevo
          </span>
          <span class="d-block d-sm-none">
            <i class="mdi mdi-plus-thick"></i>
          </span>
        </router-link>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-8 mb-2">
        <div class="form-check font-size-15" style="display: inline-block;">
          <input
            class="form-check-input"
            type="checkbox"
            id="configuracion"
            v-model="columnas.configuracion"
            @change="actualizarValoresColumnasEnLocalStorage()"
          />
          <label class="form-check-label" for="configuracion">Configuración</label>
        </div>
        &nbsp;
        <div class="form-check font-size-15" style="display: inline-block;">
          <input
            class="form-check-input"
            type="checkbox"
            id="sitio"
            v-model="columnas.sitio"
            @change="actualizarValoresColumnasEnLocalStorage()"
          />
          <label class="form-check-label" for="sitio">Sitio</label>
        </div>
        &nbsp;
        <div class="form-check font-size-15" style="display: inline-block;">
          <input
            class="form-check-input"
            type="checkbox"
            id="ultimoContacto"
            v-model="columnas.ultimo_contacto"
            @change="actualizarValoresColumnasEnLocalStorage()"
          />
          <label class="form-check-label" for="ultimoContacto">Ultimo contacto</label>
        </div>
        &nbsp;
        <div class="form-check font-size-15" style="display: inline-block;">
          <input
            class="form-check-input"
            type="checkbox"
            id="autoConfig"
            v-model="columnas.autoconfig"
            @change="actualizarValoresColumnasEnLocalStorage()"
          />
          <label class="form-check-label" for="autoConfig">Autoconfig</label>
        </div>
        &nbsp;
        <div class="form-check font-size-15" style="display: inline-block;">
          <input
            class="form-check-input"
            type="checkbox"
            id="caidas"
            v-model="columnas.caidas"
            @change="actualizarValoresColumnasEnLocalStorage()"
          />
          <label class="form-check-label" for="caidas">Caidas</label>
        </div>
        &nbsp;
        <div class="form-check font-size-15" style="display: inline-block;">
          <input
            class="form-check-input"
            type="checkbox"
            id="trafico"
            v-model="columnas.trafico"
            @change="actualizarValoresColumnasEnLocalStorage()"
          />
          <label class="form-check-label" for="trafico">Tráfico</label>
        </div>
        &nbsp;
        <div class="form-check font-size-15" style="display: inline-block;">
          <input
            class="form-check-input"
            type="checkbox"
            id="arp"
            v-model="columnas.arp"
            @change="actualizarValoresColumnasEnLocalStorage()"
          />
          <label class="form-check-label" for="arp">ARP</label>
        </div>
        &nbsp;
        <div class="form-check font-size-15" style="display: inline-block;">
          <input
            class="form-check-input"
            type="checkbox"
            id="history"
            v-model="columnas.history"
            @change="actualizarValoresColumnasEnLocalStorage()"
          />
          <label class="form-check-label" for="history">History</label>
        </div>
        &nbsp;
        <div class="form-check font-size-15" style="display: inline-block;">
          <input
            class="form-check-input"
            type="checkbox"
            id="log"
            v-model="columnas.log"
            @change="actualizarValoresColumnasEnLocalStorage()"
          />
          <label class="form-check-label" for="log">Log</label>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body" style="min-height: 475px;">
        <div class="table-responsive" style="min-height: 475px;">
          <table class="tblRouters table table-hover table-nowrap align-middle" id="tabla-router">
            <thead>
              <tr>
                <th style="width: 50px">#ID</th>
                <th>Nombre</th>
                <th>VPN</th>
                <th>API</th>
                <th>Dirección IP en VPN</th>
                <th style="width: 100px">CPEs</th>
                <th v-show="columnas.configuracion">Configuración</th>
                <th v-show="columnas.sitio">Sitio</th>
                <th v-show="columnas.ultimo_contacto">Último contacto</th>
                <th v-show="columnas.autoconfig">Autoconfig</th>
                <th v-show="columnas.caidas">Caidas</th>
                <th v-show="columnas.trafico">Tráfico</th>
                <th v-show="columnas.arp">ARP</th>
                <th v-show="columnas.history">History</th>
                <th v-show="columnas.log">Log</th>
                <th class="text-center" style="width: 50px">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="router in routers" :key="router.id">
                <td class="fw-semibold">{{ router.id }}</td>
                <td>
                  <router-link
                    :to="{
                      name: 'edicionRouter',
                      params: { id: router.id }
                    }"
                  >
                    {{ router.nombre }}
                  </router-link>
                </td>
                <td>
                  <span class="badge bg-gradient font-size-13"
                    :class="{
                      'bg-success': router.en_linea,
                      'bg-danger': !router.en_linea
                    }"
                    :title="router.en_linea == true ? 'Activo' : 'Inactivo'"
                  >
                    <i class="mdi"
                      :class="{
                        'mdi-check-bold': router.en_linea ,
                        'mdi-close-thick': !router.en_linea 
                      }"
                    ></i>
                  </span>
                </td>
                <td>
                  <span
                    class="badge bg-gradient font-size-13"
                    :class="{
                      'bg-primary': router.en_linea && router.intentos_conexion_fallidos_api == 0,
                      'bg-danger': !router.en_linea || router.intentos_conexion_fallidos_api > 0
                    }"
                    :title="router.en_linea && router.intentos_conexion_fallidos_api == 0 ? 'Correcta' : 'Error'"
                    v-if="router.configuracion != 2"
                  >
                    <i class="mdi"
                      :class="{
                        'mdi-check-bold': router.en_linea && router.intentos_conexion_fallidos_api == 0,
                        'mdi-close-thick': !router.en_linea || router.intentos_conexion_fallidos_api > 0
                      }"
                    ></i>
                  </span>
                </td>
                <td>{{ router.ip }}</td>                
                <td class="text-center">
                  <router-link
                    :to="{
                      name: 'listadoCpes',
                      params: { id_router: router.id }
                    }"
                  >
                    {{ router.cantidad_cpes.total }}
                    cpe{{
                      router.cantidad_cpes.total == 0 ||
                      router.cantidad_cpes.total > 1
                        ? 's'
                        : ''
                    }}
                  </router-link>
                </td>
                <td v-show="columnas.configuracion">
                  {{ tipoConfiguracion(router.configuracion) }}
                </td>
                <td v-show="columnas.sitio">
                  <span v-if="router.sitio != null">
                    {{ router.sitio.nombre }}
                  </span>
                </td>
                <td v-show="columnas.ultimo_contacto">
                  <span v-if="router.ultimo_contacto != null">
                    {{ fechaYHora(router.ultimo_contacto) }}
                  </span>
                </td>
                <td v-show="columnas.autoconfig">
                  <button
                    class="btn btn-light btn-sm w-100"
                    @click="mostrarAutoconfig(router)"
                  >
                    <i class="mdi mdi-cloud-download-outline text-primary"></i>
                  </button>
                </td>
                <td v-show="columnas.caidas">
                  <router-link
                    class="btn btn-light btn-sm w-100"
                    :to="{
                      name: 'registroCaidasRouter',
                      params: { id: router.id }
                    }"
                  >
                    <i class="mdi mdi-alert-circle-outline text-warning"></i>
                  </router-link>
                </td>
                <td v-show="columnas.trafico">
                  <router-link
                    :to="{ name:  $store.state.todo.nombre_empresa != 'Livaur Internet 2' ? 'tableroRouter' : 'tableroRouter2', params: { id: router.id } }"
                    class="btn btn-light btn-sm w-100"
                  >
                    <i class="mdi mdi-chart-bell-curve-cumulative text-success"></i>
                  </router-link>
                </td>
                <td v-show="columnas.arp">
                  <router-link 
                    :to="{
                      name: 'arpRouter',
                      params: { id: router.id }
                    }"
                    class="btn btn-light btn-sm w-100"
                  >
                    <i class="mdi mdi-lan"></i>
                  </router-link>
                </td>
                <td v-show="columnas.history">
                  <router-link 
                    :to="{
                      name: 'historyRouter',
                      params: { id: router.id }
                    }"
                    class="btn btn-light btn-sm w-100"
                  >
                    <i class="mdi mdi-format-list-bulleted"></i>
                  </router-link>
                </td>
                <td v-show="columnas.log">
                  <router-link 
                    :to="{
                      name: 'logRouter',
                      params: { id: router.id }
                    }"
                    class="btn btn-light btn-sm w-100"
                  >
                    <i class="mdi mdi-notebook-outline"></i>
                  </router-link>
                </td>
                <td class="text-center">
                  <div class="dropdown">
                    <button
                      class="btn btn-light btn-sm dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="bx bx-dots-horizontal-rounded"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li v-show="!columnas.autoconfig">
                        <button
                          class="dropdown-item primary"
                          @click="mostrarAutoconfig(router)"
                        >
                          <i class="mdi mdi-cloud-download-outline font-size-15 text-primary"></i>
                          Autoconfig
                        </button>
                      </li>
                      <li v-show="!columnas.caidas">
                        <router-link
                          :to="{
                            name: 'registroCaidasRouter',
                            params: { id: router.id }
                          }"
                          class="dropdown-item warning"
                        >
                          <i class="mdi mdi-alert-circle-outline font-size-15 text-warning"></i>
                          Caidas
                        </router-link>
                      </li>
                      <li v-show="!columnas.trafico">
                        <router-link
                          :to="{ 
                            name: 'tableroRouter',
                            params: { id: router.id }
                          }"
                          class="dropdown-item success"
                        >
                          <i class="mdi mdi-chart-bell-curve-cumulative font-size-15 text-success"></i>
                          Tráfico
                        </router-link>
                      </li>
                      <li v-show="!columnas.arp">
                        <router-link 
                          :to="{
                            name: 'arpRouter',
                            params: { id: router.id }
                          }"  
                          class="dropdown-item dark"
                        >
                          <i class="mdi mdi-lan font-size-15 text-dark"></i>
                          ARP
                        </router-link>
                      </li>
                      <li v-show="!columnas.history">
                        <router-link 
                          :to="{
                            name: 'historyRouter',
                            params: { id: router.id }
                          }"  
                          class="dropdown-item dark"
                        >
                          <i class="mdi mdi-format-list-bulleted font-size-15 text-dark"></i>
                          History
                        </router-link>
                      </li>
                      <li v-show="!columnas.log">
                        <router-link 
                          :to="{
                            name: 'logRouter',
                            params: { id: router.id }
                          }"  
                          class="dropdown-item dark"
                        >
                          <i class="mdi mdi-notebook-outline font-size-15 text-dark"></i>
                          Log
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{ name: 'edicionRouter', params: { id: router.id } }"
                          class="dropdown-item warning"
                        >
                          <i class="mdi mdi-content-save-edit-outline font-size-15 text-warning"></i>
                          Editar
                        </router-link>
                      </li>
                      <li>
                        <button
                          class="dropdown-item danger"
                          @click="preguntaEliminar(router)"
                        >
                          <i class="mdi mdi-trash-can-outline font-size-15 text-danger"></i>
                          Eliminar
                        </button>
                      </li>
                      <li></li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="5"></td>
                <td class="text-right">
                  <strong> {{ total_cpes }} cpes </strong>
                </td>
                <td colspan="9"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <mdl-filtros
      ref="MdlFiltros"
      :en_linea_router="en_linea"
      :desconectados_router="desconectados"
      :conexion_api_router="conexion_api"
      :error_api_router="error_api"
      @actualizar-routers="actualizarRouters($event)"
    />

    <mdl-autoconfig ref="MdlAutoconfig"/>
    <br>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main.vue"
import Filtrador from '@/components/Filtrador.vue'
import RouterSrv from '@/services/RouterSrv.js'
import MdlFiltros from "./MdlFiltros.vue"
import MdlAutoconfig from "./MdlAutoconfig.vue"
import Swal from 'sweetalert2'
import moment from 'moment'
import API from '@/API.js'
export default {
  name: 'ListadoRouters',
  components: { Layout, Filtrador, MdlFiltros, MdlAutoconfig },
  data() {
    return {
      baseUrl: window.location.origin,
      dato: '',
      en_linea: false,
      desconectados: false,
      conexion_api: false,
      error_api: false,

      routers: [],
      total_cpes: 0,
      mostrar_spinner: true,
      columnas: {
        configuracion: true,
        sitio: true,
        ultimo_contacto: true,
        autoconfig: true,
        caidas: false,
        trafico: false,
        arp: false,
        history: false,
        log: false
      },

      intervals: {
        actualizacion: null
      },
    }
  },
  created: function() {
    var self = this

    if (this.$route.query.dato) this.dato = this.$route.query.dato
    if (this.$route.query.en_linea) this.en_linea = ["1", 1, "true", true].includes(this.$route.query.en_linea)
    if (this.$route.query.desconectados) this.desconectados = ["1", 1, "true", true].includes(this.$route.query.desconectados)
    if (this.$route.query.conexion_api) this.conexion_api = ["1", 1, "true", true].includes(this.$route.query.conexion_api)
    if (this.$route.query.error_api) this.error_api = ["1", 1, "true", true].includes(this.$route.query.error_api)

    self.refrescarRouters()

    // Carga de las columnas visibles
    self.cargarValoresColumnasDeLocalStorage()

    self.intervals.actualizacion = setInterval(function() {
      self.mostrar_spinner = false
      self.refrescarRouters()
    }, 30000)
  },
  beforeUnmount() {
    clearInterval(this.intervals.actualizacion)
  },
  methods: {
    actualizarRouters(event) {
      var self = this

      self.en_linea = event.en_linea
      self.desconectados = event.desconectados
      self.conexion_api = event.conexion_api
      self.error_api = event.error_api

      self.refrescarRouters()
    },

    actualizarTotalCpes: function() {
      var self = this
      self.total_cpes = 0
      self.routers.forEach(function(router, index) {
        self.total_cpes += router.cantidad_cpes.total
      })
    },

    actualizarValoresColumnasEnLocalStorage() {
      let self = this
      localStorage.setItem('argusblack.listadoRouters.columnas', JSON.stringify(self.columnas))
    },

    cargarValoresColumnasDeLocalStorage() {
      let self = this
      let columnas = localStorage.getItem('argusblack.listadoRouters.columnas')
      
      if(columnas == null) return

      columnas = JSON.parse(columnas)
      Object.assign(self.columnas, columnas)
    },

    fechaYHora(mt) {
      return moment(mt, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY hh:mm:ss')
    },

    mostrarMdlFiltros: function() {
      var self = this
      self.$refs.MdlFiltros.mostrar()
    },

    mostrarAutoconfig: function(router) {
      var self = this
      self.$refs.MdlAutoconfig.mostrar(router.id)
    },

    preguntaEliminar: function(router) {
      var self = this

      const swal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success me-1",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      swal.fire({
        title: "Eliminación de router",
        html: '¿Está seguro que desea eliminar el router <strong>'+router.nombre+'</strong>?',
        icon: "warning",
        confirmButtonText: `<i class="mdi mdi-check-bold"></i> Si`,
        cancelButtonText: `<i class="mdi mdi-cancel"></i> No`,
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          RouterSrv.eliminar(router.id).then(response => {
            swal.fire("Eliminado!", "Se eliminó correctamente", "success");
            self.refrescarRouters()
            self.actualizarTotalCpes()
          }).catch(error => {
            let mensaje
            try {
              mensaje = error.response.data.message
            } catch (e) {
              mensaje = ''
            }
            iu.msg.error(mensaje)
            console.log(error)
          })
        } else if ( result.dismiss === Swal.DismissReason.cancel ) {
          swal.fire("Cancelar", "Se canceló la operación correctamente", "error");
        }
      })
    },

    refrescarRouters: function() {
      var self = this
      
      if(self.mostrar_spinner) iu.spinner.mostrar('#tabla-router')

      self.$router.replace({
        query: {
          dato: self.dato,
          en_linea: self.en_linea,
          desconectados: self.desconectados,
          conexion_api: self.conexion_api,
          error_api: self.error_api
        }
      }).catch(error => {})

      let params = { 
        dato: self.dato,
        con_sitio: true,
        en_linea: self.en_linea,
        desconectados : self.desconectados,
        conexion_api: self.conexion_api,
        error_api: self.error_api
      }

      RouterSrv.routersJSON(params).then(response => {
        self.routers = response.data
        self.actualizarTotalCpes()
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudieron cargar los routers'
        }
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        if(self.mostrar_spinner) iu.spinner.ocultar('#tabla-router')
        self.mostrar_spinner = true
      })
    },

    tipoConfiguracion: function(conf){
      switch (conf) {
        case 1: return 'Administración automática'; break;
        case 2: return 'Solo conectado a la VPN'; break;
        case 3: return 'Balanceador'; break;
        default: return 'Administración automática'; break;
      }
    }
  },

  mounted() {
    iu.spinner.mostrar('#tabla-router')
  }
}
</script>

<style scoped>
.text-truncate {
  width: 420px;
}
</style>